import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var System = /*#__PURE__*/function () {
  function System() {
    _classCallCheck(this, System);
  }
  _createClass(System, null, [{
    key: "arraycopy",
    value: function arraycopy(src, srcPos, dest, destPos, len) {
      var c = 0;
      for (var i = srcPos; i < srcPos + len; i++) {
        dest[destPos + c] = src[i];
        c++;
      }
    }
  }, {
    key: "getProperty",
    value: function getProperty(name) {
      return {
        'line.separator': '\n'
      }[name];
    }
  }]);
  return System;
}();
export { System as default };